import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { StreamsFilterAction, NodeStreamsFilterAction } from './streamsFilter.action';
import { streamsFilterInitialState } from './streamsFilter.constant';
import { IStreamsFilterStore } from './streamsFilter.interface';

export const streamsFilterReducer = reducerWithInitialState(streamsFilterInitialState)
  .case(StreamsFilterAction.select, (state, payload) => {
    const { streamId } = payload;

    return {
      ...state,
      selectedStream: streamId,
    };
  })
  .case(StreamsFilterAction.toggleSelect, (state, payload) => {
    const { streamId } = payload;
    if (state.selectedStream === streamId) {
      return {
        ...state,
        selectedStream: undefined,
      };
    }
    return {
      ...state,
      selectedStreamsPool: undefined,
      selectedStream: streamId,
    };
  })
  .case(NodeStreamsFilterAction.toggleSelectNode, (state, payload) => {
    const { nodeId } = payload;
    if (state.selectedStreamsPool === nodeId) {
      return {
        ...state,
        selectedStreamsPool: undefined,
      };
    }
    return {
      ...state,
      selectedStreamsPool: nodeId,
      selectedStream: undefined,
    };
  })
  .cases([StreamsFilterAction.clearSelect, NodeStreamsFilterAction.clearSelect], (state) => {
    return {
      ...state,
      selectedStream: undefined,
      selectedStreamsPool: undefined,
    };
  })
  .cases([StreamsFilterAction.destroy, NodeStreamsFilterAction.destroy], (): IStreamsFilterStore => {
    return {
      ...streamsFilterInitialState,
    };
  });
